import { render, staticRenderFns } from "./PreviewDocumentModal.vue?vue&type=template&id=3f57100b&scoped=true"
import script from "./PreviewDocumentModal.vue?vue&type=script&lang=ts"
export * from "./PreviewDocumentModal.vue?vue&type=script&lang=ts"
import style0 from "./PreviewDocumentModal.vue?vue&type=style&index=0&id=3f57100b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f57100b",
  null
  
)

export default component.exports